import React, {
  ChangeEvent,
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import styled from 'styled-components';
import { Menubar as PrimeReactMenuBar } from 'primereact/menubar';
import ConfirmDialog from 'components/UI/ConfirmDialog';
import Text from 'components/UI/Text';
import { useStores } from 'stores/hooks/hooks';
import Input from 'components/UI/Input';
import Grid from 'components/UI/Grid/Grid';
import { MenuItem } from 'primereact/menuitem';
import { AREA_UNITS } from 'core/constants';
import { ActionMode } from 'models/shared';
import NotificationUploadS3Dialog from './NotificationUploadS3Dialog/NotificationUploadS3Dialog';
import NotificationTemplateEditDialog from './NotificationTemplateEditDialog/NotificationTemplateEditDialog';
// import CouponManagementDialog from './CouponManagementDialog/CouponManagementDialog';

const StyledInput = styled(Input)`
  background-color: ${(p) => p.theme.palette.background.default};
`;

const StyledPrimeReactMenuBar = styled(PrimeReactMenuBar)`
  .p-submenu-list {
    width: auto;
  }

  .p-menuitem-text {
    text-wrap: nowrap;
  }
`;

const SelectedNodeTitle = styled(Text)`
  color: ${({ theme }) => theme.color.text};
  font-weight: 600;
`;

const defaultUnitValue = AREA_UNITS[0].id;

interface MenuBarEndComponentsProps {
  handleSearchChange: (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => void;
}

const MenuBarEndComponents: FC<MenuBarEndComponentsProps> = ({
  handleSearchChange,
}) => {
  const { t } = useTranslation('users');

  return (
    <Grid gap="1rem" direction="row">
      {/* <StartSelect /> */}
      <StyledInput
        size="small"
        placeholder={t('search')}
        type="text"
        onChange={handleSearchChange}
      />
    </Grid>
  );
};

const Menubar: FC<{ selectedTab: number }> = ({ selectedTab }) => {
  const { t } = useTranslation('notifications');
  const { notificationStore } = useStores();

  const [menuModel, setMenuModel] = useState<MenuItem[]>([]);
  const [notificationActionMode, setNotificationActionMode] =
    useState<ActionMode>(ActionMode.CREATE);

  const [notificationManagementDialog, setNotificationManagementDialog] =
    useState(false);

  const [s3UploadDialog, setS3UploadDialog] = useState(false);
  const [loadingTestNotification, setLoadingTestNotification] = useState(false);

  const handleSearchChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      // resellersStore.setGlobalFilter((event.target.value || '').trim());
    },
    [],
  );

  const onCreate = useCallback(() => {
    setNotificationActionMode(ActionMode.CREATE);
    // setNotificationManagementDialog(true);
  }, []);

  const openEditDialog = useCallback(() => {
    setNotificationManagementDialog(true);
  }, []);

  const closeEditDialog = useCallback(() => {
    setNotificationManagementDialog(false);
  }, []);

  const openUploadS3Dialog = useCallback(() => {
    setS3UploadDialog(true);
  }, []);

  const closeUploadS3Dialog = useCallback(() => {
    setS3UploadDialog(false);
  }, []);

  const handleTestNotification = useCallback(async () => {
    if (!notificationStore.selectedTemplate) {
      return;
    }

    setLoadingTestNotification(true);
    notificationStore
      .testTemplateNotification(
        notificationStore.selectedTemplate.notificationTypeId,
        notificationStore.selectedTemplate.templateName,
        notificationStore.selectedTemplate.language,
      )
      .finally(() => {
        setLoadingTestNotification(false);
      });
  }, [notificationStore]);

  const notificationItems: MenuItem[] = useMemo(
    () => [
      {
        label: t('edit_template'),
        icon: 'pi pi-fw pi-pencil',
        disabled: !notificationStore.selectedTemplate,
        command: () => {
          openEditDialog();
        },
      },
      {
        label: t('upload_s3'),
        icon: 'pi pi-fw pi-plus',
        command: () => {
          openUploadS3Dialog();
        },
      },
      {
        label: t('test_template'),
        icon: 'pi pi-fw pi-bell',
        disabled: !notificationStore.selectedTemplate,
        command: () => {
          handleTestNotification();
        },
        loading: loadingTestNotification,
      },
    ],
    [t, notificationStore.selectedTemplate, loadingTestNotification, openEditDialog, openUploadS3Dialog, handleTestNotification],
  );

  useEffect(() => {
    setMenuModel(notificationItems);
  }, [notificationItems]);

  console.log('notificationManagementDialog', notificationManagementDialog);

  return (
    <div>
      <StyledPrimeReactMenuBar
        model={menuModel}
      // end={<MenuBarEndComponents handleSearchChange={handleSearchChange} />}
      />
      {s3UploadDialog && (
        <NotificationUploadS3Dialog
          onHide={closeUploadS3Dialog}
          visible={s3UploadDialog}
          title={t('upload_s3')}
        />
      )}
      {notificationManagementDialog && (
        <NotificationTemplateEditDialog
          onHide={closeEditDialog}
          visible={notificationManagementDialog}
          title={t('edit_template')}
        />
      )}
    </div>
  );
};

export default observer(Menubar);
